
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";
    import componentTitle from './componentTitle.vue';
    import defectList from './defectList.vue';

    interface TitleData {
        text: string;
        icon: string;
        clickFun: string;
    }

    interface State {
        titleText: string;
        titleData: TitleData;
        defectList: object[];
        listName: string;
        listDefectNumber: number;
        importantNumber: number;
        listSumNumber: number;
        reportLevel: number;
    }

    export default defineComponent({
        name: "AccidentLCheck",
        setup() {
            let state: State = reactive({
                titleText: '事故检测',
                titleData: {
                    text: '标准说明',
                    icon: 'shuoming.png',
                    clickFun: 'showRemind',
                    modelCnt: [
                        '【事故检测标准】根据检测项目中是否出现凹陷、钣金修复、变形、更换、喷漆修复、切割等状态和出现以上状态的受损程度，来综合判断此车是否存在重大事故车风险。',
                        'prop_up_height',
                        '【重大事故认定标准】左右底大边、不可拆水箱框架、四个翼子板内衬、后围板、导水槽、行李箱封边、车顶边、车顶、两后翼子板存在切割，车身底板、行李箱底板、前后纵梁、前后减震器座、行李箱隔板、防火墙、左右A/B/C/D柱内侧存在钣金修复、严重变形、切割。 具体标准详见268V检测认证承诺书附件《268V检测认证标准》。'
                    ]
                },
                defectList: [],
                listName: '事故检测',
                listDefectNumber: 0,
                importantNumber: 0,
                listSumNumber: 0,
                reportLevel: 0,
            })
            const {query} = useRoute();
            state.reportLevel = Number(`${query.reportLevel}`) || 0;
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {accident} = data;
                const {importantItemCount, defectItemCount, itemCount, itemList, itemTitle} = accident
                state.defectList = itemList
                state.listName = itemTitle
                state.listDefectNumber = defectItemCount
                state.importantNumber = importantItemCount
                state.listSumNumber = itemCount
            })
            return {
                state
            }
        },
        components: {
            componentTitle, defectList
        }
    })
